export default "__VITE_ASSET__BNBlCeBO__"